import { Button } from "PFComponents/button";
import { Id } from "PFTypes";
import { useTranslation } from "react-i18next";
import { createSearchParams, useNavigate } from "react-router";

type ManageRolesButtonProps = {
  engagementId: Id;
};

export const ManageRolesButton = ({ engagementId }: ManageRolesButtonProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles" });
  const navigate = useNavigate();

  const handleClick = () => {
    navigate({
      pathname: "/activities/manage_roles",
      search: `?${createSearchParams({ engagementIds: JSON.stringify([engagementId]) })}`
    });
  };

  return <Button kind="secondary" text={t("title")} onClick={handleClick} />;
};
